/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 2026/06/10 09:35
 */

import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as w05F2040Actions from "../../../actions/w05/w05F2040/w05F2040-actions";
import EventTracking from "../../common/tracking/event";
import GridContainer from "../../common/grid-container/grid-container";
import {browserHistory} from "react-router";
import Config from "../../../config";
import {Column, Summary, TotalItem} from "devextreme-react/data-grid";
import GridActionBar from "../../common/action-bar/grid-action-bar";
import notify from "devextreme/ui/notify";
import * as userActions from "../../../actions/user-actions";
import {DateBox, CheckBox as CheckBoxExtreme} from "devextreme-react";
import DropDownSalePerson from "../../common/dropdown/template/dropdown-sale-person";
import DropDownTypeTime from "../../common/dropdown/template/dropdown-type-time";
import DropDownSaleGroup from "../../common/dropdown/dropdown-sale-group";
import * as templateDropdownActions from "../../../actions/template-dropdown-actions";
import moment from "moment";
import 'moment/locale/vi'
import Link from "../../common/link/link";
import Combo from '../../common/dropdown/dropdown-new';
import ButtonExport from '../../common/button/button-export';
import { Row, Col, Label as LabelCore, NumberInput, Typography, Collapse, Dropdown, ButtonIcon } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import { Loading } from "../../common/loading/loading";
import * as w05F2041Actions from "../../../actions/w05/w05F2041/w05F2041-actions";
moment.locale('vi');

const FormID = "W05F2040";
const Label = (props) => <LabelCore type={"h4"} {...props} />;

const useStyles = makeStyles({
    moneyInputColumn: {
        width: '100%',
        margin: 0,
        '& input': {
            textAlign: 'right'
        }
    },
});
class W05F2040Page extends React.PureComponent {
    constructor(props) {
        super(props);
    
        this.state = {
            iPermission: 0,
            collapse: false,
            voucherNum: '',
            dateFrom: '',
            dateTo: '',
            salesPersonID: '',
            customerID: '',
            groupSalesID: '',
            typeTime: '',
            search: '',
            resetSP: false,
            loading: false,
            isDetail: 0,
            inventories: [],
            statusSOIDs: "", 
            statusPaymentIDs: "",
            dataCboStatusSOID: [],
            dataCboStatusPaymentID: [],
        };

        this.filter = {
            skip: 0,
            limit: 50,
        };

        this.isReload = !!props.location.state;
        this.mode = '';
        this.timer = null;
        this.timeDeplay = 3000;
        this.isFilterUpdating = false;
    };

    toggle() {
        const {collapse} = this.state;

        this.setState({
            collapse: !collapse,
            salesPersonID: '',
            customerID: '',
            voucherNum: '',
            time: '',
            groupSalesID: '',
        });
    }

    loadGrid() {
        const uName = Config.profile.UserID;
        const divisionID = Config.profile.DivisionID || '';
        const {voucherNum, groupSalesID, salesPersonID, customerID, dateFrom, dateTo, search, isDetail, inventories, statusSOIDs, statusPaymentIDs} = this.state;
        const {skip, limit} = this.filter;
        const InventoryArr = inventories.map(item => item.value);
        const params = {
            UserID: uName,
            DivisionID: divisionID,
            Language: Config.language || '84',
            StrSearch: search,
            skip: skip,
            limit: limit,
            VoucherNum: voucherNum,
            GroupSalesID: groupSalesID,
            SalesPersonID: salesPersonID,
            CustomerID: customerID,
            DateFrom: dateFrom,
            DateTo: dateTo,
            DataType: "",
            InventoryID: JSON.stringify(InventoryArr),
            IsDetail: isDetail ? 1 : 0,
            StatusSOID:statusSOIDs, 
            StatusPaymentID:statusPaymentIDs,
        };
        this.setState({ loading: true });
        this.props.w05F2040Actions.loadGrid(params, () => {
            this.setState({ loading: false });
            if (this.isFilterUpdating) this.isFilterUpdating = false;
        });
    }

    onAddNew = () => {
        const param = {
            ...this.state
        };

        Config.setStoreState(this, param);
        browserHistory.push({
            pathname: Config.getRootPath() + 'W05F2041',
            state: {
                mode: 'add',
                // formCall: 'W05F2040'
            }
        })
    };

    getNumValue() {
        const param = {
            tranTypeID: 'NotQuantitySalesOrder'
        };

        this.props.w05F2040Actions.getNumValue(param, (error) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                switch (errorCode) {
                    case "US004":
                        message = Config.lang("Tai_khoan_dang_nhap_hoac_mat_khau_khong_dung");
                        break;
                    default:
                        message = error?.message || Config.lang("Loi_chua_xac_dinh");
                        break;
                }
                Config.popup.show('INFO', message);
                return false;
            }

        })
    };

    onRedirect(state) {

        const param = {
            ...this.state
        };

        Config.setStoreState(this, param);
        browserHistory.push({
            pathname: Config.getRootPath() + 'W05F2041',
            state
        })
    }
    onEdit =(e) =>{
        const dataRow = e.row.data;
        const param = {
            Language: Config.language || '84',
            QuotationID: dataRow.QuotationID,
            DivisionID: dataRow.DivisionID

        };
        this.setState({ loading: true });
        this.props.w05F2040Actions.checkEdit(param,(error,data) =>{
            this.setState({ loading: false });
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                return false;
            }
            if (!data) {
                let message =  Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                return false;
            }
            if (data.Status === 0) {
                this.onRedirect({
                    mode: "edit",
                    QuotationID: param.QuotationID,
                    LinkMaster: dataRow.LinkMaster,
                    //DivisionID: param.DivisionID,
                    // formCall: 'W05F2040'
                })
                return false
            }
            Config.popup.show('INFO', data.Message);
        })
    }
    onChangePage(page) {
        this.filter.skip = page * this.filter.limit;
        this.loadGrid();
    }

    onChangePerPage(per) {
        this.filter.skip = 0;
        this.filter.limit = per;
        this.loadGrid();
    }

    onSearch = (text) => {
        this.filter.skip = 0;
        this.setState({
            search: text
        }, () => {
            this.loadGrid();
        });
    };

    async loadPermission() {
        await this.props.userActions.getPermission(Config.profile.UserID, "D05F1621", (iPer) => {
            this.setState({iPermission: iPer});
        });
    }

    renderAction(e) {
        let customerPer = 0;
        const {data} = e || {};
        if (e && e.data.AStatusID !== 1) customerPer = this.state.iPermission;

        return (
            <GridActionBar
                isPer={customerPer}
                tooltipEdit={Config.lang("Sua")}
                onEditAction={() => {
                    this.onEdit(e)
                }}

                tooltipDelete={Config.lang("Xoa")}
                onDeleteAction={() => {
                    this.onDelete(e)
                }}
                btnHamburger={[
                    {
                        name: Config.lang("Tien_do_don_hang"),
                        icon: 'fas fa-sliders-h text-orange',
                        // disabled: iPermissionOrder < 2,
                        // className: iPermissionOrder < 2 ? 'isDisabled' : '',
                        onClick: () => {
                            // if (iPermissionOrder >= 2) {
                            browserHistory.push({
                                pathname: Config.getRootPath() + "W19F1021",
                                state: {...data, ScreenID: 'W05F2040'}
                            });
                            // }
                        }
                    },
                ]}
            />
        );
    }

    loadFilters() {
        Config.getStoreState(this, () => {
            this.isFilterUpdating = true;
            this.loadGrid();
        });
    }

    componentDidMount = async () => {
        await this.loadPermission();
        if (!this.isReload) this.loadData();
        this.loadFilters();
        if (this.state.iPermission <= 0) return;
        this.getNumValue();
        await this.loadCboInventoryAndDecimal(); //Combo
        await this.loadCboInventoryAndDecimal(true); // Decimal
        await this.loadCboW05F2040('LoadStatusSO');
        await this.loadCboW05F2040('LoadStatusPayment');
    };

    loadCboW05F2040 = (method = '') =>{
        const params = {
            UserID: Config.profile.UserID || "",
            Language: Config.language || "84",
            DivisionID: "",
            StrSearch: "",
            skip: 0,
            limit: 1,
            CompanyID: "",
            VoucherNum: "",
            GroupSalesID: "",
            SalesPersonID: "",
            CustomerID: "",
            DateFrom: null,
            DateTo: null,
            IsDetail: 0,
            DataType: method,
        };
        this.props.w05F2040Actions.loadCbow05f2040( params, (error, data) => {
            if (error) {
                const message = error?.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
                switch (true) {
                    case data && method === "LoadStatusSO":
                         this.setState({dataCboStatusSOID: data})
                        break;
                    case data && method === "LoadStatusPayment":
                            this.setState({dataCboStatusPaymentID: data})
                        break;
                    default:
                        break;
                }
            }
        )
    }

    loadCboInventoryAndDecimal = (isDecimal = false) => {
        const params = {
            UserID: Config.profile.UserID || "",
            Language: Config.language || "84",
            DivisionID: "",
            StrSearch: "",
            skip: 0,
            limit: 1,
            CompanyID: "",
            VoucherNum: "",
            GroupSalesID: "",
            SalesPersonID: "",
            CustomerID: "",
            DateFrom: null,
            DateTo: null,
            IsDetail: 0,
            DataType: isDecimal ? "LoadOriginalDecimal" : "cbmInventoryID"
        };
        this.props.w05F2040Actions.loadCboInventoryAndDecimal(params, (error) => {
            if (error) {
                const message = error?.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
        });
    };

    onDelete(data) {

        const rowData = data.row.data;
        const param = {
            Language: Config.language || '84',
            QuotationID: rowData.QuotationID,
            DivisionID: rowData.DivisionID

        };
        Config.popup.show("YES_NO", `${Config.lang("Ban_co_chac_chan_muon_xoa_du_lieu_nay")}`, () => {
            this.props.w05F2040Actions.deleteGrid(param, (error,data) => {
                if (error) {

                    let message = error.message || Config.lang("Loi_chua_xac_dinh");
                    Config.popup.show('INFO', message);
                    return false;
                }

                if (!data) {
                    let message =  Config.lang("Loi_chua_xac_dinh");
                    Config.popup.show('INFO', message);
                    return false;
                }
                if ( data.Status === 0) {
                    notify( data.Message || Config.lang("Du_lieu_da_xoa_thanh_cong"), "success", 400);
                    this.loadGrid();

                }else{
                    Config.popup.show('INFO', data.Message);
                }




            })
        })

    }

    loadGridTimeout() {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            this.loadGrid();
        }, this.timeDeplay / 3);
    }

    loadData() {
        //Function lấy từ combo typetime. Mặc đinh load ban đầu lấy dateform và dateto lấy từ sever trả ra.
        const sLanguage = Config.language || '84';
        const param = {
            "sLanguage": sLanguage,
            "listType": 'W19F1020_TypeTime',
        };

        this.props.templateDropdownActions.cboTypeTime(param, (error, data) => {

            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show('INFO', message);
                return false;
            }
            let defaultTimeType = 0;
            if (data && data.length > 0) {
                const defaultValue = data.filter((row) => {
                    return row.IsDefault === 1;
                });

                if (defaultValue.length > 0) {
                    defaultTimeType = defaultValue[0].ID;
                }

            }
            this.getDateFromTo(defaultTimeType);
        });
    }

    getDateFromTo(ID) {
        switch (ID) {
            case 'TODAY':
                this.setState({
                    dateFrom: moment().startOf('day').format('YYYY-MM-DD'),
                    dateTo: moment().endOf('day').format('YYYY-MM-DD')
                });
                break;
            case 'YESTERDAY':
                this.setState({
                    dateFrom: moment().add(-1, 'day').startOf('day').format('YYYY-MM-DD'),
                    dateTo: moment().add(-1, 'day').endOf('day').format('YYYY-MM-DD')
                });
                break;
            case 'THISWEEK':
                this.setState({
                    dateFrom: moment().startOf('week').format('YYYY-MM-DD'),
                    dateTo: moment().endOf('week').format('YYYY-MM-DD')
                });
                break;
            case 'LASTWEEK':
                this.setState({
                    dateFrom: moment().add(-1, 'week').startOf('week').format('YYYY-MM-DD'),
                    dateTo: moment().add(-1, 'week').endOf('week').format('YYYY-MM-DD')
                });
                break;
            case 'THISMONTH':
                this.setState({
                    dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
                    dateTo: moment().endOf('month').format('YYYY-MM-DD')
                });
                break;
            case 'LASTMONTH':
                this.setState({
                    dateFrom: moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
                    dateTo: moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
                });
                break;
            case 'THISQUARTER':
                this.setState({
                    dateFrom: moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'),
                    dateTo: moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD')
                });
                break;
            case 'LASTQUARTER':
                this.setState({
                    dateFrom: moment().quarter(moment().quarter() - 1).startOf('quarter').format('YYYY-MM-DD'),
                    dateTo: moment().quarter(moment().quarter() - 1).endOf('quarter').format('YYYY-MM-DD')
                });
                break;
            case 'THISYEAR':
                this.setState({
                    dateFrom: moment().startOf('year').format('YYYY-MM-DD'),
                    dateTo: moment().endOf('year').format('YYYY-MM-DD')
                });
                break;
            case 'LASTYEAR':
                this.setState({
                    dateFrom: moment().add(-1, 'year').startOf('year').format('YYYY-MM-DD'),
                    dateTo: moment().add(-1, 'year').endOf('year').format('YYYY-MM-DD')
                });
                break;
            default:
                this.setState({
                    dateFrom: moment().startOf('day').format('YYYY-MM-DD'),
                    dateTo: moment().endOf('day').format('YYYY-MM-DD')
                });
                break;
        }
        this.loadGrid();
    }

    changeTime = (e) => {
        this.filter.skip = 0;
        const {mode, TypeTime, DateTo, DateFrom} = e;
        let param = {
            typeTime: TypeTime,
        };
        if (!this.isFilterUpdating) param = {...param, dateTo: DateTo, dateFrom: DateFrom};
        const {dateFrom, dateTo, collapse} = this.state;

        if (collapse && mode === 'init' && dateFrom && dateTo) return;
        this.setState(param, () => {
            this.loadGrid();
        });

    };

    changeVoucherNum = e => {
        this.filter.skip = 0;
        this.setState({
            voucherNum: e.target.value
        });
        this.loadGridTimeout();
    };

    changeSalesGroup = e => {
        this.filter.skip = 0;
        this.setState({
            groupSalesID: e,
            salesPersonID: '',
            resetSP: true
        });
        this.loadGrid();
    };

    changeCustomer = e => {
        this.filter.skip = 0;
        this.setState({
            customerID: e.target.value
        });
        this.loadGridTimeout();
    };

    changeSalesPerson = e => {
        this.filter.skip = 0;
        this.setState({
            resetSP: false,
            salesPersonID: e ? e.SalesPersonID : null
        });
        this.loadGrid();
    };

    changeDateFrom = e => {
        this.filter.skip = 0;
        this.setState({
            dateFrom: e
        });
        this.loadGrid();
    };

    changeDateTo = e => {
        this.filter.skip = 0;
        this.setState({
            dateTo: e
        });
        this.loadGrid();
    };

    onDetail = (e) => {
        const data = e.row.data;
        if (!e || !data.QuotationID) return null;

        return {
            pathname: Config.getRootPath() + 'W05F2041',
            state: {
                mode: 'view',
                // formCall: 'W05F2040',
                QuotationID:data.QuotationID,
                LinkMaster:data.LinkMaster,
            }
        };
    };

    storeState = () => {
        const param = {
            ...this.state
        };
        Config.setStoreState(this, param);
    };

    renderVoucherNum = (e) => {
        const {data} = e;
        /* eslint-disable */
        return (
            <Link getData={() => this.onDetail(e)}
                storeState={this.storeState}>
                {data.VoucherNum && data.VoucherNum}
            </Link>
        )
        /* eslint-enable */
    };

    onChangeIsDetail = () => {
        const { isDetail } = this.state;
        this.setState({ isDetail: !isDetail }, () => this.loadGrid());
    };

    handleDeleteInventory = (inventories) => {
        this.setState({ inventories }, () => this.loadGrid());
    };

    handleAddInventory = (inventories) => {
        this.setState({ inventories }, () => this.loadGrid());
    };


    onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;    
        let result;
        switch (fieldName) {
            case 'statusSOIDs':
                result = e?.value || e?.target?.value || '';
                break;
            case 'statusPaymentIDs':
                result = e?.value || e?.target?.value || '';
                break;
            default:
                break;
        }
        this.setState({ [fieldName]: result }, () => this.loadGrid());
    };

    renderNumberFormat = (e) => {
        if (!e) return false;
        let limitDecimal = 0;
        const { column: { dataField }, row: { data } } = e;
        const { decimalScaleColumn } = this.props;
        let decimalValue = data[dataField];
        if (Config.typeOf(decimalValue, 'undefined')) return;
        const classes = useStyles();
        switch (dataField) {
            case "CQuantity":
            case "AfterDesCQuantity":
            case "UnitPrice":
            case "AfterDesUnitPrice":
            case "AfterDesCAmount":
                limitDecimal = decimalScaleColumn.find(item => item.ID === dataField)?.OriginalDecimal ?? 0;
                break;
            default:
                break;
        }
        if (!Config.isEmpty(decimalValue) && Config.typeOf(decimalValue, 'string')) decimalValue = Number(decimalValue);
        return <NumberInput readOnly nonStyle className={classes.moneyInputColumn} thousandSeparator={","} decimalDigit={limitDecimal} value={decimalValue} />
    };

    headerCellRender = (e) => {
        const { column: { dataField, caption } } = e;
        if (e?.cellElement?.style) {
            e.cellElement.style.position = 'relative';
            e.cellElement.style.paddingRight = '20px';
        }
        const allDataPin = Config.getLocalStorage("PIN_COLUMN", true)?.[Config.profile.UserID];
        const currentDataPin = allDataPin?.[FormID] || [];
        const currentFixed = e.component.columnOption(dataField, "fixed");
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span type={"h5"}>{caption || ""}</span>
                <ButtonIcon width={18} height={18}
                    style={{
                        position: "absolute",
                        top: 0,
                        right: 0
                    }}
                    onClick={() => {
                        e.component.columnOption(dataField, "allowSorting", false);
                        e.component.columnOption(dataField, "fixed", !currentFixed);
                        if (!currentFixed) {
                            Config.setLocalStorage("PIN_COLUMN", JSON.stringify({ [Config.profile.UserID]: { ...allDataPin, [FormID]: [...currentDataPin, dataField] } }));
                        } else {
                            if (!Config.isEmpty(currentDataPin)) {
                                const dataPinFilter = [...new Set(currentDataPin.filter(item => item !== dataField))]
                                Config.setLocalStorage("PIN_COLUMN", JSON.stringify({ [Config.profile.UserID]: { ...allDataPin, [FormID]: dataPinFilter } }));
                            }
                        }
                    }}
                    viewType={'ghost'}
                    name={currentDataPin.includes(dataField) ? 'Pin' : 'UnPin'} />
            </div>)
    };

    propsColumn = (dataField) => {
        const currentDataPin = Config.getLocalStorage("PIN_COLUMN", true)?.[Config.profile.UserID]?.[FormID] || [];
        const fixed = currentDataPin.includes(dataField);
        return {
            fixed,
            headerCellRender: this.headerCellRender,
            visibleIndex: null,
            fixedPosition: "left",
            minWidth: 120
        };
    };

    render() {
        const classes = useStyles();
        const {dataGrid, dataCboInventory } = this.props;
        const {skip, limit} = this.filter;
        const {
            typeTime, dateTo, dateFrom, groupSalesID, customerID, salesPersonID,
            iPermission, voucherNum, collapse, search, resetSP, isDetail, inventories, loading,
            statusSOIDs, statusPaymentIDs, dataCboStatusSOID, dataCboStatusPaymentID
        } = this.state;
        const btnCRM = [
            {
                buttonName: Config.lang("Xuat_du_lieu"),
                buttonType: 'button',
                icon: 'fas fa-file-excel text-green',
                align: 'right',
                disabled: false,
                onClick: () => {
                    if (this.exportRef.getWrappedInstance().onClick) {
                        this.exportRef.getWrappedInstance().onClick("0")
                    }
                }
            },
            {
                buttonName: Config.lang("Loc"),
                buttonType: 'button',
                icon: 'fas fa-filter text-yellow',
                align: 'right',
                disabled: false,
                onClick: () => {
                    this.toggle()
                }
            }];
        const InventoryArr = inventories.map(item => item.value);
        
        const paramExport = [
            { "id": "UserID", "type": "VarChar", "value": Config.profile.UserID },
            { "id": "Language", "type": "VarChar", "value": Config.language || '84' },
            { "id": "DivisionID", "type": "VarChar", "value": Config.profile.DivisionID },
            { "id": "StrSearch", "type": "NVarChar", "value": search },
            { "id": "skip", "type": "Int", "value": skip },
            { "id": "limit", "type": "Int", "value": limit },
            { "id": "CompanyID", "type": "VarChar", "value": customerID },
            { "id": "VoucherNum", "type": "VarChar", "value": voucherNum },
            { "id": "GroupSalesID", "type": "VarChar", "value": groupSalesID },
            { "id": "SalesPersonID", "type": "VarChar", "value": salesPersonID },
            { "id": "CustomerID", "type": "VarChar", "value": Config.profile.SalesPersonID || '' },
            { "id": "DateFrom", "type": "DATETIME", "value": dateFrom },
            { "id": "DateTo", "type": "DATETIME", "value": dateTo },
            { "id": "IsDetail", "type": "TINYINT", "value": isDetail ? 1 : 0 },
            { "id": "DataType", "type": "VarChar", "value": 'REPORT' },
            { "id": "InventoryID", "type": "Array", "value": InventoryArr },
            { "id": "ReportTypeID", "type": "VarChar", "value": 'W05F2040' },
            { "id": "StatusSOID", "type": "VarChar", "value": statusSOIDs },
            { "id": "StatusPaymentID", "type": "VarChar", "value": statusPaymentIDs }
        ];
        
        return (
            <div className="page-container">
            {loading && <Loading />}
                <ButtonExport
                    className="hide"
                    ref={ref => this.exportRef = ref}
                    reportTypeID={"W05F2040"}
                    id={'slave1'}
                    onlyShowPopup
                    param={paramExport}
                />
                <EventTracking action={"FORM"} label={"W05F2040"} />
                <Row>
                    <Col xs={12}><Typography color={"info"} type={"h4"}>{Config.lang("Danh_sach_don_dat_hang")}</Typography></Col>
                    <Col xs={12}>
                        <Collapse open={collapse}>
                            <div className={"mgb4x"}>
                                <FilterCondition resetSP={resetSP}

                                    voucherNum={voucherNum}
                                    onChangeVoucherNum={this.changeVoucherNum}

                                    salesGroup={groupSalesID}
                                    onChangeSalesGroup={this.changeSalesGroup}

                                    customer={customerID}
                                    onChangeCustomer={this.changeCustomer}

                                    salesPersonID={salesPersonID}
                                    onChangeSalesPerson={this.changeSalesPerson}

                                    typeTime={typeTime}
                                    onChangeTime={this.changeTime}

                                    dateFrom={dateFrom}
                                    onChangeDateFrom={this.changeDateFrom}

                                    dateTo={dateTo}
                                    onChangeDateTo={this.changeDateTo}

                                    isDetail={isDetail}
                                    inventories={inventories}
                                    statusSOIDs={statusSOIDs}
                                    dataCboStatusSOID={dataCboStatusSOID}
                                    statusPaymentIDs={statusPaymentIDs}
                                    dataCboStatusPaymentID={dataCboStatusPaymentID}
                                    dataCboInventory={dataCboInventory}
                                    onChangeIsDetail={this.onChangeIsDetail}
                                    handleDeleteInventory={this.handleDeleteInventory}
                                    handleAddInventory={this.handleAddInventory}
                                    onChangeField={this.onChange}
                                />
                            </div>
                        </Collapse>
                        <GridContainer
                            dataSource={dataGrid}
                            totalItems={dataGrid && dataGrid.length > 0 ? dataGrid[0].TotalRecord : 0}
                            itemPerPage={limit}
                            skipPerPage={skip}
                            onAddNew={this.onAddNew}
                            isPer={iPermission}
                            buttonCRM={btnCRM}
                            height={Config.getHeightGrid()}
                            listPerPage={[10, 20, 30, 50]}
                            valueSearch={search}
                            onSearch={this.onSearch}
                            onChangePage={(page) => {
                                this.onChangePage(page)
                            }}
                            onChangePerPage={(per) => {
                                this.onChangePerPage(per)
                            }}
                            gridProps={{
                                onCellPrepared: (e) => {
                                    if (e?.rowType === "header" && e?.cellElement) {
                                        e.cellElement.style.position = 'relative';
                                    }
                                }
                            }}
                        >

                            <Column
                                cellRender={(data) => this.renderAction(data)}
                                caption={Config.lang('Hanh_dong')}
                                alignment={'center'}
                                allowSorting={false}
                                fixed={true}
                                showInColumnChooser={false}
                                width={120}
                            />
                            <Column
                                {...this.propsColumn("DivisionID")}
                                dataField={'DivisionID'}
                                caption={Config.lang("Don_vi_ban")}
                                allowSorting={true}
                            />
                            <Column
                                {...this.propsColumn("VoucherNum")}
                                dataField={'VoucherNum'}
                                caption={Config.lang("So_don_hang")}
                                cellRender={(e) => this.renderVoucherNum(e)}
                                allowSorting={true}
                            />
                            <Column
                                {...this.propsColumn("CreateDate")}
                                dataField={'CreateDate'}
                                alignment={'center'}
                                dataType={'date'}
                                format={'dd/MM/yyyy HH:mm:ss'}
                                caption={Config.lang("Ngay_tao")}
                            />
                            <Column
                                {...this.propsColumn("SalesPersonName")}
                                dataField={'SalesPersonName'}
                                caption={Config.lang("Nguoi_lap")}

                            />
                            <Column
                                {...this.propsColumn("ObjectID")}
                                dataField={'ObjectID'}
                                caption={Config.lang("Ma_khach_hang")}
                            />
                            <Column
                                {...this.propsColumn("CustomerNameU")}
                                dataField={'CustomerNameU'}
                                caption={Config.lang("Khach_hang")}
                            />
                            <Column
                                {...this.propsColumn("AStatus")}
                                dataField={'AStatus'}
                                caption={Config.lang("Trang_thai_don_hang")}
                                cellRender={({ value, data }) => {
                                    const colorStatus = data?.StatusColor;
                                    return <span style={{ color: colorStatus}}>{value}</span>
                                }}
                            />
                            <Column
                                {...this.propsColumn("StatusVoucher")}
                                dataField={'StatusVoucher'}
                                caption={Config.lang("Trang_thai_thanh_toan")}
                                cellRender={({ value, data }) => {
                                    const colorStatus = data?.StatusPaymentColor ;
                                    return <span style={{ color: colorStatus}}>{value}</span>
                                }}
                            />
                            <Column
                                caption={Config.lang("Tong_so_luong_SP")}
                                dataField={'TotalQuantity'}
                                dataType={"number"}
                            />
                            <Column
                                caption={Config.lang("Tong_tien")}
                                dataField={'TotalAdjAmount'}
                                dataType={"number"}
                                width={200}
                                cellRender={({ value }) => {
                                    return <NumberInput 
                                        decimalDigit={8}
                                        thousandSeparator={","}
                                        value={value}
                                        className={classes.moneyInputColumn}
                                        viewType={'none'}
                                    />
                                }}
                            />
                            <Column
                                {...this.propsColumn("SalesPersonNameU")}
                                dataField={'SalesPersonNameU'}
                                caption={Config.lang("NVKD")}
                            />
                            <Column
                                {...this.propsColumn("DescriptionU")}
                                dataField={'DescriptionU'}
                                caption={Config.lang("Ghi_chu")}
                                alignment={'left'}

                            />
                            <Column
                                {...this.propsColumn("InventoryID")}
                                width={180}
                                visible={isDetail}
                                dataField={"InventoryID"}
                                caption={Config.lang("Ma_hang")}
                            />
                            <Column
                                {...this.propsColumn("InventoryName")}
                                width={270}
                                visible={isDetail}
                                dataField={"InventoryName"}
                                caption={Config.lang("Ten_hang")}
                            />
                            <Column
                                {...this.propsColumn("ShortName")}
                                width={200}
                                visible={isDetail}
                                dataField={"ShortName"}
                                caption={Config.lang("Ten_tat")}
                            />
                            <Column
                                {...this.propsColumn("UnitID")}
                                width={90}
                                visible={isDetail}
                                dataField={"UnitID"}
                                caption={Config.lang("DVT")}
                            />
                            <Column
                                {...this.propsColumn("CQuantity")}
                                width={150}
                                visible={isDetail}
                                dataType={"number"}
                                alignment={"right"}
                                dataField={"CQuantity"}
                                caption={Config.lang("So_luong_QD")}
                                cellRender={this.renderNumberFormat}
                            />
                            <Column
                                {...this.propsColumn("AfterDesCQuantity")}
                                width={150}
                                visible={isDetail}
                                dataType={"number"}
                                alignment={"right"}
                                dataField={"AfterDesCQuantity"}
                                caption={Config.lang("So_luong_sau_DC")}
                                cellRender={this.renderNumberFormat}
                            />
                            <Column
                                {...this.propsColumn("UnitPrice")}
                                width={150}
                                visible={isDetail}
                                dataType={"number"}
                                alignment={"right"}
                                dataField={"UnitPrice"}
                                caption={Config.lang("Don_gia")}
                                cellRender={this.renderNumberFormat}
                            />
                            <Column
                                {...this.propsColumn("AfterDesUnitPrice")}
                                width={150}
                                visible={isDetail}
                                dataType={"number"}
                                alignment={"right"}
                                dataField={"AfterDesUnitPrice"}
                                caption={Config.lang("Don_gia_sau_DC")}
                                cellRender={this.renderNumberFormat}
                            />
                            <Column
                                {...this.propsColumn("AfterDesCAmount")}
                                width={150}
                                visible={isDetail}
                                dataField={"AfterDesCAmount"}
                                dataType={"number"}
                                alignment={"right"}
                                caption={Config.lang("Thanh_tien_sau_DC")}
                                cellRender={this.renderNumberFormat}
                            />
                            <Summary>
                                <TotalItem
                                    column={'TotalQuantity'} // So_luong_SP
                                    summaryType={'sum'}
                                    displayFormat={"{0}"}
                                />
                                <TotalItem
                                    column={'TotalAdjAmount'} // Tong_tien
                                    summaryType={'sum'}
                                    displayFormat={"{0}"}
                                    valueFormat={(e) => Config.numberFormat(e, 8)}
                                />
                            </Summary>
                        </GridContainer>
                    </Col>
                </Row>
            </div>
        )
    }
}

export class FilterCondition extends React.PureComponent {

    onChangeTime(data, mode) {
        if (!data) return false;
        const {DateFrom, DateTo, ID} = data;
        const time = {
            mode: mode,
            TypeTime: ID,
            DateFrom: DateFrom ? moment(DateFrom).format('YYYY-MM-DD') : null,
            DateTo: DateTo ? moment(DateTo).format('YYYY-MM-DD') : null,
        };

        this.props.onChangeTime && this.props.onChangeTime(time);
    }


    render() {
        const {
            voucherNum, onChangeVoucherNum, onChangeCustomer, onChangeSalesPerson,
            onChangeSalesGroup, salesPersonID, onChangeDateTo, typeTime, salesGroup,
            dateFrom, dateTo, onChangeDateFrom, customer, resetSP, dataCboInventory,
            isDetail, inventories, handleAddInventory, handleDeleteInventory, onChangeIsDetail,
            dataCboStatusSOID, dataCboStatusPaymentID, onChangeField, statusPaymentIDs, statusSOIDs
        } = this.props;

        return (
            <Row>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang('So_don_hang')}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <input
                                value={voucherNum}
                                onChange={(e) => {
                                    onChangeVoucherNum && onChangeVoucherNum(e)
                                }}
                                className={'form-control'}/>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang('Khach_hang')}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <input
                                value={customer}
                                onChange={(e) => {
                                    onChangeCustomer && onChangeCustomer(e)
                                }}
                                className={'form-control'}/>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang('Nhom_kinh_doanh')}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <DropDownSaleGroup showClearButton={true}
                                placeholder={Config.lang('Nhom_kinh_doanh')}
                                value={salesGroup}
                                onChange={(e) => {
                                    onChangeSalesGroup && onChangeSalesGroup(e);
                                }}/>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang('Nhan_vien_kinh_doanh')}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <DropDownSalePerson showClearButton={true}
                                placeholder={Config.lang("Nhan_vien_kinh_doanh")}
                                value={salesPersonID}
                                reset={resetSP}
                                groupSalesID={salesGroup}
                                onChange={(e) => {
                                    onChangeSalesPerson && onChangeSalesPerson(e);
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang('Thoi_gian')}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <DropDownTypeTime
                                listType={"W19F1020_TypeTime"}
                                value={typeTime}
                                placeholder={""}
                                onChange={(data, mode) => this.onChangeTime(data, mode)}
                            >
                            </DropDownTypeTime>
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12} className={"display_row align-right"}>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <DateBox
                                dateSerializationFormat={'yyyy-MM-dd'}
                                width={"100%"}
                                placeholder={Config.lang("Tu_ngay")}
                                id={'CreateDateFrom'}
                                openOnFieldClick={true}
                                useMaskBehavior={true}
                                showClearButton={true}
                                value={dateFrom}
                                type={'date'}
                                pickerType={"calendar"}
                                showAnalogClock={false}
                                displayFormat={'dd/MM/y'}
                                onValueChanged={(e) => {
                                    onChangeDateFrom && onChangeDateFrom(e.value);
                                }}
                            />
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                            <DateBox
                                dateSerializationFormat={'yyyy-MM-dd'}
                                width={"100%"}
                                placeholder={Config.lang("Den_ngay")}
                                id={'CreateDateTo'}
                                openOnFieldClick={true}
                                useMaskBehavior={true}
                                showClearButton={true}
                                value={dateTo}
                                type={'date'}
                                pickerType={"calendar"}
                                showAnalogClock={false}
                                displayFormat={'dd/MM/y'}
                                onValueChanged={(e) => {
                                    onChangeDateTo && onChangeDateTo(e.value);
                                }}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang("Mat_hang")}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Combo
                                defaultValue={inventories}
                                placeholder={Config.lang("Mat_hang")}
                                dataSource={dataCboInventory}
                                handleDelete={(e) => { handleDeleteInventory && handleDeleteInventory(e) }}
                                onActionWhenSelectChange={(e) => { handleAddInventory && handleAddInventory(e) }}
                                displayExpr={"customNameID"}
                                valueExpr={"value"}
                                isMulti={true}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang("Trang_thai_thanh_toan")}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Dropdown
                                clearAble
                                viewType={'outlined'}
                                value={statusPaymentIDs}
                                valueExpr={'StatusPaymentID'}
                                displayExpr={'StatusPaymentName'}
                                dataSource={dataCboStatusPaymentID || []}
                                onChange={e => onChangeField('statusPaymentIDs', e)}
                            />  
                        </Col>
                    </Row>
                </Col>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <Row>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Label>{Config.lang("CRM_Trang_thai_don")}</Label>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Dropdown
                                clearAble
                                viewType={'outlined'}
                                valueExpr={'StatusSOID'}
                                value={statusSOIDs}
                                displayExpr={'StatusSOName'}
                                dataSource={dataCboStatusSOID || []}
                                onChange={e => onChangeField('statusSOIDs', e)}
                            />  
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} md={6} sm={12} xs={12} className={"display_row align-center"}>
                    <CheckBoxExtreme
                        text={Config.lang("Hien_thi_chi_tiet")}
                        lang={Config.lang("Hien_thi_chi_tiet")}
                        value={!!isDetail}
                        onValueChanged={() => {
                            onChangeIsDetail && onChangeIsDetail();
                        }}
                    />
                </Col>
            </Row>
        )
    }
}

export default connect(state => ({
    dataGrid: state.w05F2040.dataGrid,
    numValue: state.w05F2040.numValue,
    decimalScaleColumn: state.w05F2040.dataGrid,
    dataCboInventory: state.w05F2040.dataCboInventory,
    dataCboStatusSOID: state.w05F2040.dataCboStatusSOID,
    dataCboStatusPaymentID: state.w05F2040.dataCboStatusPaymentID,
}),
    (dispatch) => ({
        w05F2040Actions: bindActionCreators(w05F2040Actions, dispatch),
        templateDropdownActions: bindActionCreators(templateDropdownActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        w05F2041Actions: bindActionCreators(w05F2041Actions, dispatch),
    })
)(W05F2040Page);
